const getVideoThumbnail = (video) => {
  if (video.provider === "YOUTUBE") {
    if (video.videoLink.includes("youtu.be/")) {
      const videoId = video.videoLink.split("youtu.be/")[1]?.split("?")[0];
      return videoId
        ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
        : null;
    }
    if (video.videoLink.includes("youtube.com/watch?v=")) {
      const videoId = video.videoLink.split("v=")[1]?.split("&")[0];
      return videoId
        ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
        : null;
    }
  } else if (video.provider === "VIMEO") {
   return video["thumbnail"]
  }
  return null;
};

export default getVideoThumbnail;
